define('drops/treeView/singleSelection',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var SingleSelection = function (drop) {
        this.idOfSelectedNode = null;

        this.drop = drop;

        var self = this;
        this.drop.$tree.bind(
            'tree.select',
            function (e) {
                self.selectNode(e.node);
            }
        );
    };

    SingleSelection.prototype.onCreateLi = $.noop;
    
    SingleSelection.prototype.getSelection = function() {
        return this.idOfSelectedNode;
    };

    SingleSelection.prototype.replaceWith = function (idOfNode) {
        var node = this.drop.$tree.tree('getNodeById', idOfNode);
        this.drop.$tree.tree('selectNode', node);

        this.selectNode(node);
        this.drop.$tree.tree('addToSelection', node);
        this.drop.$tree.tree('scrollToNode', node);
    };

    SingleSelection.prototype.selectNode = function (node) {
        this.deselect();

        if (node) {
            this.idOfSelectedNode = node.id;
            this.drop.showAsSelected(node);
            this.drop.$tree.tree('openNode', node);
            this.drop.triggerEventIfEnabled('selected', node.id);
        } else if (this.idOfSelectedNode) {
            this.drop.triggerEventIfEnabled('deselected', this.idOfSelectedNode);
            this.idOfSelectedNode = null;
        }

        this.drop.updateRequiredIndicator();
    };

    SingleSelection.prototype.reset = function () {
        this.deselect();
        this.idOfSelectedNode = null;
    };

    SingleSelection.prototype.deselect = function () {
        if (this.idOfSelectedNode) {
            var currentNode = this.drop.$tree.tree('getNodeById', this.idOfSelectedNode);
            this.drop.showAsDeselected(currentNode);
        }
    };

    SingleSelection.prototype.reselect = function () {
        if (!this.idOfSelectedNode) return;

        var node = this.drop.$tree.tree('getNodeById', this.idOfSelectedNode);

        if (node) {
            this.drop.$tree.tree('clear');
            this.drop.$tree.tree('addToSelection', node);
            this.drop.showAsSelected(node);
        } else {
            this.idOfSelectedNode = null;
        }
    };

    return SingleSelection;
});
